var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.total > 0)?_c('span',{class:[
    'notification-pill new-notification tw-px-2 tw-py-1 tw-rounded-full tw-text-xs tw-font-normal tw-shadow tw-leading-none tw-inline-block tw-text-center',
    { 'tw-bg-blue-500 tw-text-white' : !_vm.dumb },
    { 'new-notification--pulse' : _vm.hasNewNotification && !_vm.dumb },
    { 'tw-bg-gray-500' : !_vm.hasNewNotification },
 ]},[_vm._v(_vm._s(_vm.total))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }